module.exports = __webpack_public_path__ + "img/POLY.e5257dec.svg";